import { useDispatch } from "react-redux";
import { updateConfig } from "../../../../store/slices/Printing/printingSlice";
import { useFormik } from "formik";
import { getEstimateType } from "../CertificateList/api";
import { useEffect, useState } from "react";

const useEstimateForm = () => {
  const dispatch = useDispatch();

  const [estimateTypes, setEstimateTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getEstimateType();
        setEstimateTypes(response.data.data.estimate_types);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  const formik = useFormik({
    initialValues: {
      estimate_type: null,
      remark: "",
    },
    validate: (values) => {
      let errors = {};
      if (!values?.estimate_type ) {
        errors.estimate_type = "Select Estimate Type";
      }
      if (!values?.remark || !values.remark.trim()) {
        errors.remark = "Enter remark";
      }
      return errors;
    },
    onSubmit: (values, { setSubmitting }) => {
      // const Ids = values?.gli?.map((val) => val?._id);
      // dispatch(
      //   updateConfig((state) => {
      //     state.selectedId = Ids;
      //     state.showTable = true;
      //     state.isMultiGliPrint = false;
      //   })
      // );
      setSubmitting(false);
    },
  });

  const handleCancel = () => {
    dispatch(
      updateConfig((state) => {
        state.isMultiGliPrint = false;
        state.isMultiPrint = false;
      })
    );
  };

  const handleItemChange = (val) => {
    formik?.setFieldValue("estimate_type", val);
  };

  return {
    formik,
    estimateTypes,
    handleCancel,
    handleItemChange,
  };
};

export default useEstimateForm;
